import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Drug, Batch, GlobalResponse } from '@app/shared-module/models';
import { InventoryService } from '../inventory.service';
import { Constants } from '@app/shared-module/constants';
import { MatDialogRef, MatDialog } from '@angular/material';
import { EditDialogComponent } from '../edit-dialog/edit-dialog.component';
import { ConfirmationDialogComponent } from '@app/shared-module/confirmation-dialog/confirmation-dialog.component';
import { CommonService } from '@app/shared-module/common-service.service';
import { ToastrService } from 'ngx-toastr';
import { CreateDrugDialogComponent } from '../create-drug-dialog/create-drug-dialog.component';
import { EditThreshholdComponent } from '../edit-threshhold/edit-threshhold.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-inv-items',
  templateUrl: './inv-items.component.html',
  styleUrls: ['./inv-items.component.scss']
})
export class InvItemsComponent implements OnInit {
  @Input() item: Drug;
  @Input() clinicId: string;
  @Output() categoryChanged = new EventEmitter();
  batches: Batch[] = [];
  open = false;
  @BlockUI() blockUI: NgBlockUI;
  editDialogRef: MatDialogRef<EditDialogComponent>;
  editThreshDialogRef: MatDialogRef<EditThreshholdComponent>;
  createDialogRef: MatDialogRef<CreateDrugDialogComponent>;
  confirmDialogRef: MatDialogRef<ConfirmationDialogComponent>;

  constructor(
    private service: InventoryService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
  }
  openItem(item: Drug) {
    this.open = !this.open;
    if (!(this.batches && this.batches.length > 0 && item.batches && item.batches.length > 0)) {
      this.blockUI.start();
      this.service.getBatchList(this.clinicId, item._id).subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          this.batches = res.result.batch;
        }
      });
    }
  }

  editValues(item) {
    // console.log('editValues');
    // console.log(item);
    this.editDialogRef = this.dialog.open(EditDialogComponent, {
      disableClose: false
    });
    this.editDialogRef.componentInstance.headerTitle = 'Edit Item';
    this.editDialogRef.componentInstance.doctorId = this.commonService.internalLoginValue._id;
    this.editDialogRef.componentInstance.clinicId = this.clinicId;
    this.editDialogRef.componentInstance.category = item.category;
    this.editDialogRef.componentInstance.name = item.name;
    this.editDialogRef.componentInstance.manuf = item.manufacturer;
    this.editDialogRef.componentInstance.instrc = item.instructions;
    this.editDialogRef.componentInstance.seller_name = item.supplier;
    // this.editDialogRef.componentInstance.price = item.price;
    this.editDialogRef.componentInstance.drugId = item._id;

    this.editDialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log('closed status');
        this.categoryChanged.emit(false);
      }
      this.editDialogRef = null;
    });
  }

  editThreshValues(item) {
    this.editThreshDialogRef = this.dialog.open(EditThreshholdComponent, {
      disableClose: false
    });
    this.editThreshDialogRef.componentInstance.headerTitle = 'Edit Reorder Level';
    this.editThreshDialogRef.componentInstance.threshold = item.threshold_qty;
    // this.editDialogRef.componentInstance.clinicId = this.clinicId;
    this.editThreshDialogRef.componentInstance.drugId = item._id;
    this.editThreshDialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log('closed status');
        this.categoryChanged.emit(false);
      }
      this.editThreshDialogRef = null;
    });
  }

  editBatchValues(batchItem: any, item: any) {
    // console.log('editValues');
    // console.log(batchItem);
    this.editDialogRef = this.dialog.open(EditDialogComponent, {
      disableClose: false
    });
    this.editDialogRef.componentInstance.headerTitle = 'Edit Batch Item';
    this.editDialogRef.componentInstance.doctorId = this.commonService.internalLoginValue._id;
    this.editDialogRef.componentInstance.clinicId = this.clinicId;
    this.editDialogRef.componentInstance.batchFlag = true;
    this.editDialogRef.componentInstance.rack_no = batchItem.rack_no;
    this.editDialogRef.componentInstance.seller_name = batchItem.seller_name;
    this.editDialogRef.componentInstance.drugId = item._id;
    this.editDialogRef.componentInstance.name = item.name;
    this.editDialogRef.componentInstance.batchId = batchItem._id;
    this.editDialogRef.componentInstance.price = batchItem.selling_price;

    this.editDialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log('closed status');
        this.categoryChanged.emit(false);
      }
      this.editDialogRef = null;
    });
  }

  addNewBatch(item: any) {
    // console.log('editValues');
    // console.log(item);
    this.createDialogRef = this.dialog.open(CreateDrugDialogComponent, {
      disableClose: false
    });
    this.createDialogRef.componentInstance.headerTitle = 'Create New Batch';
    this.createDialogRef.componentInstance.doctorId = this.commonService.internalLoginValue._id;
    this.createDialogRef.componentInstance.clinicId = this.clinicId;
    // this.createDialogRef.componentInstance.batchFlag = true;
    // this.createDialogRef.componentInstance.name = item.name;
    this.createDialogRef.componentInstance.drugId = item._id;

    this.createDialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log('closed status');
        this.categoryChanged.emit(false);
      }
      this.createDialogRef = null;
    });
  }

  deleteItem(item: Drug) {
    this.blockUI.start();
    this.service.deleteDrugItem(item._id).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.toastr.success(Constants.SUCCESS_ITEM_DELETED);
        this.categoryChanged.emit(false);
      }
    });
  }

  deleteBatchItem(item: Drug, itemId: string) {
    this.blockUI.start();
    this.service.deleteBatchItem(this.clinicId, item._id, itemId).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.toastr.success(Constants.SUCCESS_ITEM_DELETED);
        this.categoryChanged.emit(false);
      }
    });
  }


  openDeleteConfirmationDialog(item: any, type: string, itemId: string = '') {
    this.confirmDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true
    });
    this.confirmDialogRef.componentInstance.confirmMessage = Constants.CONFIRMATION_DELETE_ITEM;

    this.confirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (type === 'item') {
          this.deleteItem(item);
        } else if (type === 'batch') {
          this.deleteBatchItem(item, itemId);
        }
      }
      this.confirmDialogRef = null;
    });
  }
}
